import React from 'react';
import './UniversalProductLibrary.css';

// SVG Icons
const ArrowLeftIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
  </svg>
);

const ChevronUpIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="18 15 12 9 6 15"/>
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

const VerifiedIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#3b82f6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12l2 2 4-4"/>
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#3b82f6" stroke="#3b82f6"/>
    <path d="M9 12l2 2 4-4" fill="none" stroke="#fff"/>
  </svg>
);

const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);

const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
  </svg>
);

const PackageIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
  </svg>
);

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const XIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

const TrendingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
  </svg>
);

const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const getQualityColor = (score) => {
  if (score >= 80) return 'green';
  if (score >= 60) return 'yellow';
  return 'red';
};

export default function UniversalProductDetails({ product, onClose, onEdit, onDelete, onVerify, onPrev, onNext }) {
  return (
    <div className="settings-page">
      {/* Header */}
      <div className="upl-subpage-header">
        <div className="upl-subpage-header-left">
          <button className="upl-back-btn" onClick={onClose}>
            <ArrowLeftIcon />
          </button>
          <div className="upl-nav-arrows">
            <button className="upl-nav-btn" onClick={onPrev} disabled={!onPrev} title="Previous product">
              <ChevronUpIcon />
            </button>
            <button className="upl-nav-btn" onClick={onNext} disabled={!onNext} title="Next product">
              <ChevronDownIcon />
            </button>
          </div>
          <div>
            <h1 className="upl-subpage-title">Product Details</h1>
            <p className="upl-subpage-subtitle">View complete product information</p>
          </div>
        </div>
        <div className="upl-subpage-actions">
          <button
            className={`upl-btn ${product.dataQuality?.isVerified ? 'verified-active' : 'outline'}`}
            onClick={onVerify}
          >
            <VerifiedIcon size={16} />
            {product.dataQuality?.isVerified ? 'Verified' : 'Verify'}
          </button>
          <button className="upl-btn danger-outline" onClick={onDelete}>
            <TrashIcon />
            Delete
          </button>
          <button className="upl-btn primary" onClick={onEdit}>
            <EditIcon />
            Edit Product
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="upl-scroll-content">
        <div className="upl-details-content">
          {/* Product Overview */}
          <div className="upl-detail-section">
            <div className="upl-overview">
              {product.primaryImageUrl ? (
                <img
                  src={product.primaryImageUrl}
                  alt={product.name}
                  className="upl-overview-image"
                />
              ) : (
                <div className="upl-overview-placeholder">
                  <PackageIcon />
                </div>
              )}
              <div className="upl-overview-info">
                <div className="upl-overview-header">
                  <div>
                    <h2 className="upl-overview-name">{product.name}</h2>
                    {product.brand && <p className="upl-overview-brand">by {product.brand}</p>}
                  </div>
                  <span className="upl-country-badge">{product.country}</span>
                </div>
                <div className="upl-overview-grid">
                  <div>
                    <p className="upl-overview-label">Category</p>
                    <p className="upl-overview-value">{product.category}</p>
                    {product.subcategory && <p className="upl-overview-sub">{product.subcategory}</p>}
                  </div>
                  {product.size && (
                    <div>
                      <p className="upl-overview-label">Size</p>
                      <p className="upl-overview-value">{product.size}</p>
                      {product.packSize && <p className="upl-overview-sub">Pack of {product.packSize}</p>}
                    </div>
                  )}
                  {product.msrp != null && (
                    <div>
                      <p className="upl-overview-label">MSRP</p>
                      <p className="upl-overview-value">${product.msrp.toFixed(2)}</p>
                    </div>
                  )}
                  {product.typicalPriceRange && (
                    <div>
                      <p className="upl-overview-label">Typical Price Range</p>
                      <p className="upl-overview-value">
                        ${product.typicalPriceRange.min.toFixed(2)} - ${product.typicalPriceRange.max.toFixed(2)}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Data Quality */}
          <div className="upl-detail-section">
            <h3 className="upl-detail-section-title">Data Quality</h3>
            <div className="upl-quality-grid">
              <div style={{ textAlign: 'center' }}>
                <div className={`upl-quality-circle ${getQualityColor(product.dataQuality?.score || 0)}`}>
                  <span>{product.dataQuality?.score || 0}</span>
                </div>
                <p className="upl-quality-circle-label">Quality Score</p>
              </div>
              <div className="upl-quality-indicators">
                <div className="upl-quality-indicator">
                  {product.dataQuality?.hasImage ? (
                    <span className="check"><CheckIcon /></span>
                  ) : (
                    <span className="cross"><XIcon /></span>
                  )}
                  <div>
                    <p className="upl-quality-indicator-label">Has Image</p>
                    <p className="upl-quality-indicator-sub">
                      {product.images?.length || 0} image{(product.images?.length || 0) !== 1 ? 's' : ''}
                    </p>
                  </div>
                </div>
                <div className="upl-quality-indicator">
                  {product.dataQuality?.hasBarcode ? (
                    <span className="check"><CheckIcon /></span>
                  ) : (
                    <span className="cross"><XIcon /></span>
                  )}
                  <div>
                    <p className="upl-quality-indicator-label">Has Barcode</p>
                    <p className="upl-quality-indicator-sub">
                      {product.upc || product.ean ? 'Present' : 'Missing'}
                    </p>
                  </div>
                </div>
                <div className="upl-quality-indicator">
                  {product.dataQuality?.isVerified ? (
                    <span className="check"><CheckIcon /></span>
                  ) : (
                    <span className="muted"><XIcon /></span>
                  )}
                  <div>
                    <p className="upl-quality-indicator-label">Verified</p>
                    <p className="upl-quality-indicator-sub">
                      {product.dataQuality?.isVerified ? 'Yes' : 'No'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Product Identifiers */}
          <div className="upl-detail-section">
            <h3 className="upl-detail-section-title">Product Identifiers</h3>
            <div className="upl-form-grid-3">
              <div>
                <p className="upl-overview-label">UPC</p>
                <p className="upl-overview-value">{product.upc || '-'}</p>
              </div>
              <div>
                <p className="upl-overview-label">EAN</p>
                <p className="upl-overview-value">{product.ean || '-'}</p>
              </div>
              <div>
                <p className="upl-overview-label">SKU</p>
                <p className="upl-overview-value">{product.sku || '-'}</p>
              </div>
              {product.manufacturer && (
                <div>
                  <p className="upl-overview-label">Manufacturer</p>
                  <p className="upl-overview-value">{product.manufacturer}</p>
                </div>
              )}
              {product.department && (
                <div>
                  <p className="upl-overview-label">Department</p>
                  <p className="upl-overview-value">{product.department}</p>
                </div>
              )}
            </div>
          </div>

          {/* Product Images */}
          {product.images && product.images.length > 0 && (
            <div className="upl-detail-section">
              <h3 className="upl-detail-section-title">Product Images ({product.images.length})</h3>
              <div className="upl-detail-images">
                {product.images.map((image, index) => (
                  <div key={index} className="upl-detail-image-item">
                    <img src={image.url} alt={`${product.name} ${index + 1}`} />
                    {image.isPrimary && (
                      <span className="upl-image-primary-badge">Primary</span>
                    )}
                    <span className="upl-detail-image-source">{image.source}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Search & Discovery */}
          <div className="upl-detail-section">
            <h3 className="upl-detail-section-title">Search & Discovery</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <p style={{ fontSize: 14, fontWeight: 500, color: '#374151', marginBottom: 8 }}>Tags</p>
                {product.tags && product.tags.length > 0 ? (
                  <div className="upl-pills">
                    {product.tags.map((tag, i) => (
                      <span key={i} className="upl-pill purple">{tag}</span>
                    ))}
                  </div>
                ) : (
                  <p style={{ fontSize: 13, color: '#6b7280' }}>No tags</p>
                )}
              </div>
              <div>
                <p style={{ fontSize: 14, fontWeight: 500, color: '#374151', marginBottom: 8 }}>Aliases</p>
                {product.aliases && product.aliases.length > 0 ? (
                  <div className="upl-pills">
                    {product.aliases.map((alias, i) => (
                      <span key={i} className="upl-pill blue">{alias}</span>
                    ))}
                  </div>
                ) : (
                  <p style={{ fontSize: 13, color: '#6b7280' }}>No aliases</p>
                )}
              </div>
              <div>
                <p style={{ fontSize: 14, fontWeight: 500, color: '#374151', marginBottom: 8 }}>Keywords</p>
                {product.keywords && product.keywords.length > 0 ? (
                  <div className="upl-pills">
                    {product.keywords.map((keyword, i) => (
                      <span key={i} className="upl-pill gray">{keyword}</span>
                    ))}
                  </div>
                ) : (
                  <p style={{ fontSize: 13, color: '#6b7280' }}>No keywords</p>
                )}
              </div>
            </div>
          </div>

          {/* Usage & Metadata */}
          <div className="upl-detail-section">
            <h3 className="upl-detail-section-title">Usage & Metadata</h3>
            <div className="upl-metadata-grid">
              <div>
                <div className="upl-match-stat">
                  <div className="upl-match-icon">
                    <TrendingIcon />
                  </div>
                  <div>
                    <div className="upl-match-count">{product.matchCount || 0}</div>
                    <div className="upl-match-label">Times Imported</div>
                  </div>
                </div>
                {product.lastMatchedAt && (
                  <p style={{ fontSize: 13, color: '#6b7280' }}>
                    Last matched: {formatDate(product.lastMatchedAt)}
                  </p>
                )}
              </div>
              <div>
                {product.source && (
                  <div className="upl-meta-item">
                    <p className="upl-meta-label">Source</p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span className="upl-badge blue" style={{ textTransform: 'capitalize' }}>
                        {product.source.name.replace(/_/g, ' ')}
                      </span>
                      {product.source.externalId && (
                        <span style={{ fontSize: 12, color: '#6b7280' }}>ID: {product.source.externalId}</span>
                      )}
                    </div>
                    <p style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
                      Imported: {formatDate(product.source.importedAt)}
                    </p>
                  </div>
                )}
                <div className="upl-meta-item">
                  <p className="upl-meta-label">Created</p>
                  <p className="upl-meta-value">{formatDate(product.created_at)}</p>
                </div>
                <div className="upl-meta-item">
                  <p className="upl-meta-label">Last Updated</p>
                  <p className="upl-meta-value">{formatDate(product.updated_at)}</p>
                </div>
                <div className="upl-meta-item">
                  <p className="upl-meta-label">Product ID</p>
                  <p className="upl-meta-value mono">{product._id}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
